type EmailValidationResult = { isValid: true; trimmedEmail: string | null } | { isValid: false; errorMessage: string };

export function isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validateEmail(email: string | null): EmailValidationResult {
    if (email === null) {
        return { isValid: true, trimmedEmail: null };
    }

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
        return { isValid: false, errorMessage: 'O email não pode estar vazio.' };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
        return { isValid: false, errorMessage: 'Por favor, insira um email válido.' };
    }

    return { isValid: true, trimmedEmail };
}
